const getters = {
  // app
  clientIp: state => state.app.clientIp,
  browser: state => state.app.browser,
  system: state => state.app.system,
  isIlisten: state => state.app.isIlisten,
  ilistenCaller: state => state.app.ilistenCaller,
  ilistenPrdVer: state => state.app.ilistenPrdVer,
  ilistenChannel: state => state.app.ilistenChannel,
  // flag
  haveCheckedAppAuth: state => state.flag.haveCheckedAppAuth,
  // user
  token: state => state.user.token,
  v4token: state => state.user.v4token,
  userId: state => state.user.userId,
  mobile: state => state.user.mobile,
  nickname: state => state.user.nickname,
  avatarUrl: state => state.user.avatarUrl,
  isVip: state => state.user.isVip,
  vipCount: state => state.user.vipCount,
  isSub: state => state.user.isSub,
  // order
  goodsId: state => state.order.goodsId,
  goodsType: state => state.order.goodsType,
  content: state => state.order.content,
  desc: state => state.order.desc,
  name: state => state.order.name,
  price: state => state.order.price,
  priceLabel: state => state.order.priceLabel,
  shareId: state => state.order.shareId,
  account: state => state.order.account,
  discountDetail: state => state.order.discountDetail,
  discountList: state => state.order.discountList,
}

export default getters
